import { configure, action, decorate } from 'mobx';
import { observable } from 'mobx';

configure({ enforceActions: 'always' });

export default class UIStore {
  constructor(APIWebSocketStore) {
    this.apiWebSocketStore = APIWebSocketStore;
    this.initialize();
  }
  
  initialize = () => {
    this.setProperty('headerText', null);
    this.setProperty('isLoading', true);
  }

  handleLogin = async (username, password, providerId) => {
    console.log('🔒 Logging in')
    await this.apiWebSocketStore.apiconnect(username, password, providerId);
  };
  
  handleStartEvent = async () => {
    
    console.log('🔒 websocket connect')
    await this.webSocketStore.connect();
  }

  handleLogout = () => this.webSocketStore.disconnect();

  setProperty = (key, value) => {
    this[key] = value;
  };

  setHeaderText = (value) => this.setProperty('headerText', value);
  getProperty = (key) => this[key];
}

decorate(UIStore, {
  setHeaderText: action,
  initialize: action,
  handleLogin: action,
  handleLogout: action,
  setProperty: action,
  getProperty: action,
  isLoading: observable,
  headerText: observable,
});
